import { Box, MenuItem, Tooltip } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { CustomViewItemActionMenuProps } from "./customViewLeftPanel/CustomViewItemActionMenu";

export interface DeleteButtonProps extends CustomViewItemActionMenuProps {}

const DeleteButton: FC<DeleteButtonProps> = observer((props: DeleteButtonProps) => {
	const { customViewItem } = props;
	const {
		deleteButtonDisabled,
		startDeleting,
	} = customViewItem;

	const action = (
		<MenuItem
			disabled={deleteButtonDisabled}
			onClick={startDeleting}
			res="CustomViewDelete"
		/>
	);

	if (deleteButtonDisabled) {
		return (
			<Tooltip res="CustomViewDeleteTooltip">
				<Box>
					{action}
				</Box>
			</Tooltip>
		);
	}

	return (
		<>
			{action}
		</>
	);
});

export default DeleteButton;